import { Colors } from "@blueprintjs/core";

const topicBorder = areaOfInterest => {
  const base = 2.67;
  return {
    features: [
      {
        type: "Feature",
        properties: {
          style: {
            weight: 2 * base,
            stroke: true,
            fill: true,
            fillOpacity: 0,
            color: Colors.WHITE
          }
        },
        geometry: areaOfInterest
      },
      {
        type: "Feature",
        properties: {
          style: {
            weight: base,
            stroke: true,
            fill: false,
            color: Colors.COBALT3,
            lineCap: "butt",
            dashArray: `${3 * base}, ${1 * base}`
          }
        },
        geometry: areaOfInterest
      }
    ]
  };
};

export default topicBorder;



// WEBPACK FOOTER //
// ./src/app/map/topicBorder.js